module.exports = __webpack_public_path__ + "img/bg-cant-find@2x.fc952d7b.jpeg";